"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const useUniqueId_1 = require("../useUniqueId");
const constants_1 = require("../utils/constants");
const Container = styled_1.default("div") `
  label: Accordion;
  height: 100%;
  display: grid;
  grid-template-rows: ${({ sections }) => sections.map(expanded => (expanded ? "1fr" : `${constants_1.headerHeight}px`)).join(" ")};
  border-top: none;
`;
const Accordion = (_a) => {
    var { onToggle, expanded, children, id } = _a, rest = __rest(_a, ["onToggle", "expanded", "children", "id"]);
    const uid = useUniqueId_1.useUniqueId(id);
    // this ref is used to detect if visitor uses mouse or keyboard
    // to show focus state in case of keyboard
    const isMouseRef = React.useRef(false);
    const [sections, setSections] = React.useState(expanded || []);
    const toggleSection = (index) => {
        if (onToggle && expanded) {
            onToggle(index);
        }
        else {
            const newSections = [...sections];
            newSections[index] = !newSections[index];
            setSections(newSections);
        }
        isMouseRef.current = false;
    };
    // number of items in state and number of childre can be different
    const sectionsMapped = React.Children.map(children, (_, index) => Boolean(onToggle && expanded ? expanded[index] : sections[index]));
    return (React.createElement(Container, Object.assign({ sections: sectionsMapped, onMouseDown: () => {
            isMouseRef.current = true;
        }, onKeyDown: () => {
            isMouseRef.current = false;
        }, "data-cy": "operational-ui__Accordion", id: uid }, rest), React.Children.map(children, (element, index) => React.cloneElement(element, Object.assign({}, element.props, { id: uid, _expanded: sectionsMapped[index], _toggleSection: toggleSection, _index: index })))));
};
exports.default = Accordion;
//# sourceMappingURL=Accordion.js.map